/* Kinde — interactividad de las páginas portadas desde Claude Design.
   Reimplementación vanilla: reveal on-scroll, galería, antes/después,
   reseñas, fechas de entrega, barra fija y dropdown "Tienda". */
(function () {
  function init() {
    // ── Reveal on scroll ──
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting || e.boundingClientRect.top < 0) {
          e.target.classList.add('is-in'); io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
    var sweep = function () {
      document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
          el.classList.add('is-in'); io.unobserve(el);
        }
      });
    };
    window.addEventListener('scroll', sweep, { passive: true }); sweep();

    // ── CTA "Comprar" → baja al formulario #pedido ──
    document.querySelectorAll('[data-kbuy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById('pedido');
        if (!d) return;
        d.style.display = 'block';
        requestAnimationFrame(function () {
          window.scrollTo({ top: d.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
        });
      });
    });

    // ── Home: dropdown "Tienda" ──
    var tbtn = document.getElementById('ktienda-btn'), tpanel = document.getElementById('ktienda');
    if (tbtn && tpanel) {
      tbtn.addEventListener('click', function () {
        tpanel.style.display = (tpanel.style.display === 'block') ? 'none' : 'block';
      });
    }

    // ── Producto: galería con puntos + miniaturas ──
    var kg = document.getElementById('kg');
    if (kg) {
      var dots = Array.prototype.slice.call(document.querySelectorAll('.kdot'));
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.kthumb'));
      var setActive = function (i) {
        dots.forEach(function (d, j) { d.style.background = j === i ? 'var(--color-accent)' : 'var(--color-neutral-300)'; });
        thumbs.forEach(function (t, j) { t.style.borderColor = j === i ? 'var(--color-accent)' : 'transparent'; });
      };
      kg.addEventListener('scroll', function () {
        if (!kg.clientWidth) return;
        setActive(Math.round(kg.scrollLeft / kg.clientWidth));
      }, { passive: true });
      var go = function (i) { kg.scrollTo({ left: kg.clientWidth * i, behavior: 'smooth' }); setActive(i); };
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); }); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.i); }); });
      setActive(0);
    }

    // ── Producto: antes / después (tirador) ──
    var kba = document.getElementById('kba');
    if (kba) {
      var clip = document.getElementById('kbaclip'), inner = document.getElementById('kbainner'),
          line = document.getElementById('kbaline'), handle = document.getElementById('kbahandle');
      var setSplit = function (pct) {
        pct = Math.max(2, Math.min(98, pct));
        if (clip) clip.style.width = pct + '%';
        if (line) line.style.left = pct + '%';
        if (handle) handle.style.left = pct + '%';
        if (inner) inner.style.width = kba.clientWidth + 'px';
      };
      var drag = function (e) {
        if (e.type === 'pointermove' && e.buttons !== 1) return;
        var r = kba.getBoundingClientRect();
        setSplit(((e.clientX - r.left) / r.width) * 100);
      };
      kba.addEventListener('pointerdown', drag);
      kba.addEventListener('pointermove', drag);
      window.addEventListener('resize', function () { setSplit(parseFloat((clip && clip.style.width) || '50')); });
      setSplit(50);
    }

    // ── Producto: fechas de entrega dinámicas ──
    var fp = document.getElementById('kfp');
    if (fp) {
      var M = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      var f = function (d) { return d.getDate() + ' ' + M[d.getMonth()]; };
      var add = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      fp.textContent = f(new Date());
      var proc = document.getElementById('kproc'); if (proc) proc.textContent = f(new Date()) + ' – ' + f(add(1));
      var ent = document.getElementById('kent'); if (ent) ent.textContent = f(add(1)) + ' – ' + f(add(4));
    }

    // ── Producto: reseñas (3 → 10) ──
    var rc = document.getElementById('kresenas');
    if (rc) {
      var R = [
        ['Valeria G.', 'Quito', 'El olor a humedad que volvía siempre por fin desapareció. La ropa sale fresca.', 4],
        ['Daniel R.', 'Guayaquil', 'Fácil de usar y se nota desde el primer lavado. Recomendado.', 6],
        ['Andrea M.', 'Cuenca', 'Vi el agua sucia que salió del tambor… no lo podía creer. Ahora la uso cada mes.', 1],
        ['José C.', 'Ambato', 'Puse la pastilla, ciclo largo y listo. Cero complicación.', 0],
        ['Gabriela P.', 'Machala', 'Mis toallas volvieron a oler a limpio. Vale cada centavo.', 3],
        ['Michelle T.', 'Manta', 'Con mascotas en casa era imprescindible. Adiós al mal olor.', 2],
        ['Carlos V.', 'Loja', 'Pagué al recibir, sin riesgo. El producto cumple.', 0],
        ['Doménica S.', 'Santo Domingo', 'La goma de la puerta quedó impecable. Súper recomendado.', 5],
        ['Fernando A.', 'Ibarra', 'Llegó rapidísimo y funciona. La ropa de bebé por fin huele bien.', 0],
        ['Karla N.', 'Portoviejo', 'Probé de todo antes. Esto sí sirvió y es fácil.', 0]
      ];
      var open = false;
      var render = function () {
        var list = open ? R : R.slice(0, 3);
        rc.innerHTML = list.map(function (r) {
          var url = (window.KINDE_REV && r[3]) ? window.KINDE_REV[r[3] - 1] : '';
          var avatar = url
            ? '<span style="flex:0 0 42px;width:42px;height:42px;border-radius:999px;overflow:hidden;background:var(--color-accent-3-100)"><img src="' + url + '" alt="' + r[0] + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block"></span>'
            : '<span style="flex:0 0 42px;width:42px;height:42px;border-radius:999px;background:var(--color-accent-3-100);display:grid;place-items:center;font-size:15px;font-weight:700;color:var(--color-accent-3-800)">' + r[0].charAt(0) + '</span>';
          return '<div class="card"><div style="display:flex;align-items:center;gap:10px">' +
            avatar +
            '<span style="font-weight:700;font-size:15px">' + r[0] + '</span>' +
            '<span style="font-size:13px;color:var(--color-muted)">' + r[1] + '</span></div>' +
            '<p class="card-body" style="color:var(--color-text)">' + r[2] + '</p>' +
            '<span style="display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:600;color:var(--color-accent-2-700)">✓ Compra verificada · ★★★★★</span></div>';
        }).join('');
      };
      render();
      var tg = document.getElementById('ktoggle');
      if (tg) tg.addEventListener('click', function () { open = !open; render(); tg.textContent = open ? 'Ver menos' : 'Ver más'; });
    }

    // ── Producto: barra "Comprar" fija (aparece al bajar) ──
    var barra = document.getElementById('kbarra');
    if (barra) {
      window.addEventListener('scroll', function () {
        barra.style.transform = window.scrollY > 420 ? 'translateY(0)' : 'translateY(120%)';
      }, { passive: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ── EasySell: pinta el botón COMPRAR AHORA con el coral de la marca (su color viene con !important, así que lo reescribimos en el estilo inline) ── */
(function () {
  var G = 'linear-gradient(180deg,#d0603a,#b84e2b)';
  var SEL = '.es-popup-button,.es-popup-button-product,.es-sticky-btn,.es-sticky-product';
  function paint() {
    document.querySelectorAll(SEL).forEach(function (b) {
      if ((b.style.background || '').indexOf('208, 96, 58') === -1) {
        b.style.setProperty('background', G, 'important');
        b.style.setProperty('box-shadow', '0 6px 18px rgba(168,71,31,.35)', 'important');
      }
    });
  }
  paint();
  try { new MutationObserver(paint).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  [400, 1000, 2200].forEach(function (t) { setTimeout(paint, t); });
})();
